import { CSSProperties, PropsWithChildren } from 'react';
import sanitizeHtml from 'sanitize-html';
import { StyledParagraph } from './styled';

export type Variant = 'extra-large' | 'large' | 'medium' | 'small';

export type ParagraphProps = PropsWithChildren<{
  variant?: Variant;
  accent?: boolean;
  span?: boolean;
  style?: CSSProperties;
  lighter?: boolean;
  semiBold?: boolean;
  bold?: boolean;
}>;

export function Paragraph({
  children,
  span = false,
  variant = 'medium',
  accent = false,
  style,
  lighter = false,
  semiBold = false,
  bold = false
}: ParagraphProps): JSX.Element {
  if (typeof children === 'string') {
    return (
      <StyledParagraph
        variant={variant}
        accent={accent}
        lighter={lighter}
        semiBold={semiBold}
        bold={bold}
        as={span === true ? 'span' : undefined}
        style={style}
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(children, { allowedTags: ['a', 'b', 'br', 'u'] })
        }}
      />
    );
  }

  return (
    <StyledParagraph
      variant={variant}
      as={span === true ? 'span' : undefined}
      style={style}
      lighter={lighter}
      semiBold={semiBold}
      bold={bold}
      accent={accent}
    >
      {children}
    </StyledParagraph>
  );
}
